import { GregorioGlyphType } from '../enums/GregorioGlyphType';
import { GregorioLiquescentia, TAIL_LIQUESCENTIA_MASK } from '../enums/GregorioLiquescentia';
import { GregorioShape } from '../enums/GregorioShape';
import { GregorioType } from '../enums/GregorioType';
import { GregorioGlyph } from '../structures/GregorioGlyph';
import { is_fused, is_initio_debilis } from './other';


export function compute_fused_shift(glyphs: GregorioGlyph[], glyph_index: number): number {
  const glyph = glyphs[glyph_index];
  if (!glyph || !is_fused(glyph.notes.liquescentia) || glyph.type !== GregorioType.GLYPH) {
    return 0;
  }

  const first_note = glyph.firstNote;
  if (!first_note || first_note.type !== GregorioType.NOTE) {
    return 0;
  }

  const previous = glyphs[glyph_index - 1]; //gregorio_previous_non_texverb_glyph(glyph);
  if (!previous || previous.type !== GregorioType.GLYPH ||
    (previous.notes.liquescentia & TAIL_LIQUESCENTIA_MASK) !== 0 || !previous.firstNote) {
    return 0;
  }

  const next = glyphs[glyph_index + 1];
  const next_is_fused =
    next &&
    next.type === GregorioType.GLYPH &&
    is_fused(next.notes.liquescentia);

  switch (glyph.notes.glyph_type) {
    case GregorioGlyphType.PORRECTUS:
    case GregorioGlyphType.PODATUS:
      if (next_is_fused) {
        return 0;
      }
      /* else it may be fused to the previous note */
      break;

    case GregorioGlyphType.PUNCTUM:
    case GregorioGlyphType.FLEXA:
      /* these may be fused to the previous note */
      break;

    default:
      /* anything else may not be fused to the previous note */
      return 0;
  }

  switch (first_note.shape) {
    case GregorioShape.QUILISMA:
    case GregorioShape.QUILISMA_QUADRATUM:
    case GregorioShape.FLAT:
    case GregorioShape.SHARP:
    case GregorioShape.NATURAL:
      /* if this glyph starts with one of these, it's not fusible */
      return 0;

    default:
      /* anything else is potentially fusible */
      break;
  }

  switch (previous.notes.glyph_type) {
    case GregorioGlyphType.PUNCTUM:
    case GregorioGlyphType.FLEXA:
    case GregorioGlyphType.VIRGA_REVERSA:
      /* these are potentially fusible to this note */
      break;

    default:
      /* everything else is not fusible */
      return 0;
  }

  const prev_note = previous.lastNote;

  // assert(
  //   prev_note.type === GRE_NOTE,
  //   "compute_fused_shift: previous note wasn't a note"
  // );

  const shift = first_note.pitch - prev_note!.pitch;
  // assert(
  //   shift >= -MAX_AMBITUS && shift <= MAX_AMBITUS,
  //   "compute_fused_shift: ambitus too large to fuse"
  // );

  if (shift > 0 && previous.notes.glyph_type === GregorioGlyphType.VIRGA_REVERSA) {
    /* virga reversa cannot fuse upwards */
    return 0;
  }

  if (shift < 0) {
    if (glyph.notes.glyph_type === GregorioGlyphType.PODATUS) {
      if (glyph.notes.liquescentia & GregorioLiquescentia.DEMINUTUS) {
        /* podatus deminutus may be fused from above */
        return shift;
      }
      switch (first_note.shape) {
        case GregorioShape.ORISCUS_ASCENDENS:
        case GregorioShape.ORISCUS_DESCENDENS:
        case GregorioShape.ORISCUS_SCAPUS_ASCENDENS:
        case GregorioShape.ORISCUS_SCAPUS_DESCENDENS:
          return shift;
        default:
          /* otherwise, podatus may not be fused from above */
          return 0;
      }
    }

    /* the FLEXA check below checks for a porrectus-like flexus, which is
     * not fusible from above */
    if (
      (next_is_fused && glyph.notes.glyph_type === GregorioGlyphType.FLEXA) ||
      glyph.notes.glyph_type === GregorioGlyphType.PORRECTUS ||
      (previous.notes.glyph_type === GregorioGlyphType.PUNCTUM &&
        is_initio_debilis(previous.notes.liquescentia))
    ) {
      /* may not be fused from above */
      return 0;
    }
  }

  return shift;
}
